// extracted by mini-css-extract-plugin
module.exports = {"container":"cim-content-card_container__r2Hyd","image":"cim-content-card_image___kvPW","highlightedTool":"cim-content-card_highlightedTool__i65Gq"};